/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Import_ActivitiesInputs */

const en_ui_intervals_import_activities = /** @type {(inputs: Ui_Intervals_Import_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import sessions`)
};

const de_ui_intervals_import_activities = /** @type {(inputs: Ui_Intervals_Import_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten importieren`)
};

/**
* | output |
* | --- |
* | "Import sessions" |
*
* @param {Ui_Intervals_Import_ActivitiesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_import_activities = /** @type {((inputs?: Ui_Intervals_Import_ActivitiesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Import_ActivitiesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_import_activities(inputs)
	return de_ui_intervals_import_activities(inputs)
});